<template>
  <v-container
    class="d-flex flex-column align-stretch overflow-y-auto record-wrapper"
    height="90vh"
  >
    <v-row max-height="100px" class="flex-sm-grow-0">
      <v-col cols="10">
        <TabBar
          v-on:saveChanges="finishEditAndUpdateRecord($event)"
          v-on:saveChangesAndCloseTab="
            finishEditAndUpdateAndCloseRecord($event)
          "
          v-on:discardChanges="finishEditAndDiscardChanges()"
          v-on:discardChangesAndCloseTab="discardChangesAndCloseTab($event)"
          v-on:switchTabs="editModeOff()"
        />
      </v-col>
      <v-col cols="2" v-if="tabIsEditable">
        <v-row>
          <div>
            <v-btn
              icon
              color="info"
              v-if="!editMode && tabs.length > 0"
              @click="editModeOn()"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-tooltip max-width="30vw" v-if="editMode" bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" class="d-inline-block">
                  <v-btn
                    color="success"
                    :disabled="!canSubmit"
                    icon
                    large
                    @click="finishEditAndUpdateRecord()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>{{ submitMessage }}</span>
            </v-tooltip>
            <v-btn
              icon
              color="error"
              v-if="editMode"
              large
              @click="finishEditAndDiscardChanges()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-row>
        <div class="mt-3" v-if="!showDateMode">
          {{ reformatTimestamp(creationDateTime, true) }}
        </div>
      </v-col>
    </v-row>

    <v-row class="overflow-y-auto mb-2" v-if="RecordItem != undefined">
      <v-col cols="12">
        <div
          v-if="this.currentlySelectedTab.type === 'record' && tabs.length > 0"
          class="recordviewer"
        >
          <v-form ref="recordForm" v-model="canSubmit" @submit.prevent>
            <RecordNode
              v-if="RecordItem.name !== 'Select a record item to view'"
              :RecordItem="RecordItem"
              :editMode="editMode"
              :showDateMode="showDateMode"
              :isRoot="true"
              :key="formKey"
              v-on:resetformplease="incrFormKey()"
            />
          </v-form>
        </div>
        <div v-if="tabs.length > 0">
          <Charts
            v-if="currentlySelectedTab.type === 'graph'"
            :isEmbedded="false"
            :key="currentlySelectedTabRecordItemId"
          />
          <EventDisplay
            v-if="currentlySelectedTab.type === 'group'"
            :editMode="false"
            :isEmbedded="false"
            :selectedRecord="SelectedRecord"
            :key="currentlySelectedTabRecordItemId"
            type="view"
          />

          <AnalysisDisplay
            v-if="currentlySelectedTab.type === 'analysis'"
            class="recordviewer"
            :isEmbedded="false"
            :key="currentlySelectedTabRecordItemId"
          />
          <div
            v-if="this.currentlySelectedTab.type === 'event' && tabs.length > 0"
            class="recordviewer"
          >
            <v-form ref="recordForm" v-model="canSubmit" @submit.prevent>
              <EventDisplay
                :editMode="editMode"
                :isEmbedded="false"
                :creationDateTime="creationDateTime"
                :selectedRecord="SelectedRecord"
                :key="currentlySelectedTabRecordItemId"
                type="event"
              />
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";

import TabBar from "./tabs/tab-bar";
import RecordNode from "./RecordNode";
import Charts from "../charts/Charts";
import AnalysisDisplay from "../analysis/AnalysisDisplay";
import EventDisplay from "../events/EventDisplay";

export default {
  components: {
    TabBar,
    RecordNode,
    Charts,
    AnalysisDisplay,

    EventDisplay,
  },
  mounted() {
    this.$root.$on(
      "menu:edit-record",
      (value, timestamp = this.currentRecordDateTimeStamp) => {
        if (value) {
          this.showDateMode = false;
          this.editModeOn();
          this.creationDateTime = timestamp;
        } else {
          //// this.editModeOff();
        }
      }
    );

    this.$root.$on("edit:update", () => {
      if (this.$refs.recordForm) {
        this.$refs.recordForm.validate();
      }
    });
  },
  computed: {
    ...mapGetters({ RecordItem: "getRecordItem" }),
    ...mapState({
      SelectedRecord: (state) => state.records.currentlySelectedRecord,
      UneditedRecordItem: (state) => state.records.uneditedCurrentRecord,
      currentlySelectedTab: (state) => state.records.currentlySelectedTab,
      currentlySelectedTabRecordItemId: (state) =>
        state.records.currentlySelectedTab.recordItemId,
      tabs: (state) => state.records.tabs,
      submitMessage: function() {
        return this.canSubmit
          ? "Submit changes"
          : "All fields are required; please add missing information";
      },
      tabIsEditable: function(state) {
        return this.editableTabTypes.includes(
          state.records.currentlySelectedTab.type
        );
      },
      currentRecordDateTimeStamp: (state) =>
        state.records.currentlySelectedTab.datetime,
    }),
  },

  data() {
    return {
      formKey: 0,
      emptyString: "",
      editMode: false,
      showDateMode: true,
      recordItemCopy: {},
      canSubmit: false,
      errorList: [],
      creationDateTime: "",
      editableTabTypes: ["record", "event"],
    };
  },
  methods: {
    ...mapActions([
      "setupUneditedRecord",
      "updateWholeRecord",
      "discardChangesAndRevertToUneditedRecord",
      "resetUneditedRecord",
      "switchToTab",
      "closeTab",
    ]),
    showDateModeOn() {
      this.showDateMode = true;
    },
    resetEditModes() {
      this.editMode = false;
      this.showDateMode = true;
    },
    editModeOn() {
      this.editMode = true;
      this.setupUneditedRecord(this.currentlySelectedTab);
      this.$nextTick(() => {
        if (this.$refs.recordForm) {
          this.$refs.recordForm.validate();
        }
      });
    },
    editModeOff() {
      this.resetUneditedRecord();
      this.resetEditModes();
    },
    finishEditAndUpdateRecord(navigatingToTab) {
      this.updateWholeRecord(this.currentlySelectedTab);
      if (navigatingToTab) {
        this.switchToTab(navigatingToTab);
      }

      this.resetEditModes();
    },
    finishEditAndUpdateAndCloseRecord(closedTab) {
      this.updateWholeRecord(closedTab);
      this.resetEditModes();
      this.closeTab(closedTab);
    },
    finishEditAndDiscardChanges() {
      this.discardChangesAndRevertToUneditedRecord(this.currentlySelectedTab);
      this.resetEditModes();
    },
    discardChangesAndCloseTab(closedTab) {
      this.discardChangesAndRevertToUneditedRecord(closedTab);

      this.resetEditModes();
    },
    incrFormKey() {
      this.formKey++;
    },
    reformatTimestamp(timestamp, showTime = false) {
      return moment(timestamp).format(
        showTime ? "MMM Do YYYY, h:mm a" : "MMM Do YYYY"
      );
    },
  },
};
</script>

<style scoped>
.record-wrapper {
  min-height: 0;
  height: 100%;
}
</style>
